var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "gift_card_trace_pane",
    },
    [
      _c(
        "div",
        { staticClass: "card-info" },
        [
          _c(
            "el-descriptions",
            { attrs: { title: "卡片信息", column: 4, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "卡片编号" } }, [
                _vm._v("\n        " + _vm._s(_vm.cardInfo.fnId) + "\n      "),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "礼品卡" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.cardInfo.giftCardTitle) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "会员卡号" } }, [
                _vm._v("\n        " + _vm._s(_vm.cardInfo.cardNo) + "\n      "),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "手机号" } }, [
                _vm._v("\n        " + _vm._s(_vm.cardInfo.mobile) + "\n      "),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "金额" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.cardInfo.cardPrice) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "充值类型" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.cardInfo.chargeType === "principal"
                        ? "本金"
                        : _vm.cardInfo.chargeType === "bonus"
                        ? "赠金"
                        : ""
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-descriptions-item",
                { attrs: { label: "当前状态" } },
                [
                  _vm.cardInfo.status === "normal"
                    ? _c("el-tag", { attrs: { type: "success" } }, [
                        _vm._v("\n          正常\n        "),
                      ])
                    : _vm.cardInfo.status === "used"
                    ? _c("el-tag", { attrs: { type: "info" } }, [
                        _vm._v("\n          已使用\n        "),
                      ])
                    : _c("el-tag", { attrs: { type: "info" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.cardInfo.status) +
                            "\n        "
                        ),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "circulation-log" },
        [
          _c("h4", [_vm._v("流转记录")]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.logData,
                stripe: "",
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "操作类型",
                  align: "center",
                  width: "120",
                  prop: "actionTypeDesc",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.actionType === "assign"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("\n            发放\n          "),
                            ])
                          : scope.row.actionType === "transfer"
                          ? _c("el-tag", { attrs: { type: "warning" } }, [
                              _vm._v("\n            转赠\n          "),
                            ])
                          : scope.row.actionType === "receive"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v("\n            领取\n          "),
                            ])
                          : scope.row.actionType === "recharge"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("\n            充值\n          "),
                            ])
                          : scope.row.actionType === "refund"
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("\n            退回\n          "),
                            ])
                          : scope.row.actionType === "convert_electronic"
                          ? _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v(
                                "\n            实体卡转电子卡\n          "
                              ),
                            ])
                          : _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.actionType) +
                                  "\n          "
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作方",
                  align: "center",
                  width: "120",
                  prop: "fromUserName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.fromUserName || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "接收方",
                  align: "center",
                  width: "120",
                  prop: "toUserName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.toUserName || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "金额",
                  align: "center",
                  width: "100",
                  prop: "amount",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "充值类型", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.chargeType === "principal"
                                ? "本金"
                                : scope.row.chargeType === "bonus"
                                ? "赠金"
                                : "-"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "变更前状态", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.beforeStatus === "normal"
                          ? _c("span", [_vm._v("正常")])
                          : scope.row.beforeStatus === "used"
                          ? _c("span", [_vm._v("已使用")])
                          : scope.row.beforeStatus === "invalid"
                          ? _c("span", [_vm._v("失效")])
                          : scope.row.beforeStatus === "transfering"
                          ? _c("span", [_vm._v("转赠中")])
                          : scope.row.beforeStatus === "transferred"
                          ? _c("span", [_vm._v("已转赠")])
                          : scope.row.beforeStatus === "refunding"
                          ? _c("span", [_vm._v("退款中")])
                          : scope.row.beforeStatus === "refunded"
                          ? _c("span", [_vm._v("已退款")])
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.beforeStatus || "-")),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "变更后状态", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.afterStatus === "normal"
                          ? _c("span", [_vm._v("正常")])
                          : scope.row.afterStatus === "used"
                          ? _c("span", [_vm._v("已使用")])
                          : scope.row.afterStatus === "invalid"
                          ? _c("span", [_vm._v("失效")])
                          : scope.row.afterStatus === "transfering"
                          ? _c("span", [_vm._v("转赠中")])
                          : scope.row.afterStatus === "transferred"
                          ? _c("span", [_vm._v("已转赠")])
                          : scope.row.afterStatus === "refunding"
                          ? _c("span", [_vm._v("退款中")])
                          : scope.row.afterStatus === "refunded"
                          ? _c("span", [_vm._v("已退款")])
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.afterStatus || "-")),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "备注", align: "center", prop: "remark" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.remark || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "时间", align: "center", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatTime(scope.row.createTime)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.logData.length === 0 && !_vm.loading
            ? _c("div", { staticClass: "empty-tip" }, [
                _vm._v("\n      暂无流转记录\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }